import CustomButton from "@Common/CustomButton";
import { ReservationMangmentHeaderWrapper } from "./styles";
import { useTranslation } from "react-i18next";
import { useSubPermissions } from "@hooks/usePermissions";
import CalendarAddIcon from "@assets/svg/calendarAdd.svg?react";
import { useSetRecoilState } from "recoil";
import { isManualReservationOpen } from "@store/index";
export default function ReservationMangmentHeader() {
  const { showReservationsManualbooking } = useSubPermissions();
  const isManualReservationOpenState = useSetRecoilState(
    isManualReservationOpen
  );
  const { t } = useTranslation();
  return (
    <ReservationMangmentHeaderWrapper>
      <div>
        <p>{t("Reservation.title")}</p>
        <span>{t("Reservation.subTitle")}</span>
      </div>
      <div>
        {showReservationsManualbooking && (
          <CustomButton
            label={t("MANUALRESERVATION.CREATEMANUALRESERVATION")}
            withBG
            customPadding="16px 90px"
            borderRadius="80px"
            withIcone
            customIcon={
              <CalendarAddIcon
                style={{
                  fontSize: "18px",
                }}
              />
            }
            onClick={() => isManualReservationOpenState(true)}
          />
        )}
      </div>
    </ReservationMangmentHeaderWrapper>
  );
}
